import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c930cfe8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "unboxing"
};
const _hoisted_2 = {
  key: 0,
  class: "loading_wrapper"
};
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"skeleton_box\" data-v-c930cfe8><div class=\"skeleton_title\" data-v-c930cfe8><div class=\"skeleton_line main\" data-v-c930cfe8></div><div class=\"skeleton_line sub\" data-v-c930cfe8></div></div><div class=\"skeleton_image\" data-v-c930cfe8></div><div class=\"skeleton_num\" data-v-c930cfe8></div><div class=\"skeleton_button\" data-v-c930cfe8></div></div>", 1);
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 0,
  class: "light"
};
const _hoisted_6 = {
  key: 1,
  class: "box_before"
};
const _hoisted_7 = {
  class: "title_area"
};
const _hoisted_8 = {
  class: "main_title"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "sub_title"
}, "自动拆开盲盒", -1));
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "num"
};
const _hoisted_12 = {
  class: "button_area"
};
const _hoisted_13 = {
  key: 2,
  class: "box_after"
};
const _hoisted_14 = {
  class: "title_area"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "main_title"
}, "恭喜你抽中", -1));
const _hoisted_16 = {
  key: 0,
  class: "sub_title"
};
const _hoisted_17 = {
  key: 0,
  class: "result_wrapper"
};
const _hoisted_18 = {
  key: 0,
  class: "hidden_tag"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  key: 1,
  class: "result_list"
};
const _hoisted_21 = {
  key: 0,
  class: "item_tag"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "item_name"
};
const _hoisted_24 = {
  key: 2,
  class: "button_area"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompLottieAnimation = _resolveComponent("CompLottieAnimation");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.pack_status === 1 && $data.packSuccessInfos.length === 1 ? (_openBlock(), _createBlock(_component_CompLottieAnimation, {
    key: 0,
    jsonUrl: "https://p6.moimg.net/mdwxapp/lottie_json/unboxing_celebration.json",
    loop: true
  })) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(['main_box', {
      'main_box_after': $data.pack_status === 1
    }])
  }, [$data.pack_status === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : _createCommentVNode("", true), $data.pack_status === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("p", _hoisted_8, "系统" + _toDisplayString($data.countdown > 0 ? '将在' + $data.countdown + 's后' : '正在'), 1), _hoisted_9]), _createElementVNode("img", {
    class: "box_img",
    src: _ctx.$imgUrlFilter($data.unpackInfo.show_img || 'https://p6.moimg.net/mdwxapp/funcinating/unboxing_init_logo.png', 344)
  }, null, 8, _hoisted_10), _createElementVNode("p", _hoisted_11, "共" + _toDisplayString($data.unpackInfo.num > 0 ? $data.unpackInfo.num : '--') + "个盲盒", 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "open_button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleUnbox && $options.handleUnbox(...args))
  }, "立即拆盒")])])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, $data.showResultWrapper && $options.displayItem ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($options.displayItem.unpacking_name || ''), 1)) : _createCommentVNode("", true)]), $data.showResultWrapper && $options.displayItem ? (_openBlock(), _createElementBlock("div", _hoisted_17, [$options.displayItem.unpacking_type_name ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($options.displayItem.unpacking_type_name), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
    class: "result_cover",
    src: _ctx.$imgUrlFilter($options.displayItem.unpacking_icon || '', 338)
  }, null, 8, _hoisted_19)])) : _createCommentVNode("", true), $data.packSuccessInfos.length > 1 && !$data.showResultWrapper ? (_openBlock(), _createElementBlock("div", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mergedPackList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "result_item",
      key: index
    }, [item.unpacking_type_name ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.unpacking_type_name), 1)) : _createCommentVNode("", true), _createElementVNode("img", {
      src: _ctx.$imgUrlFilter(item.unpacking_icon, 124),
      class: "item_cover"
    }, null, 8, _hoisted_22), _createElementVNode("p", _hoisted_23, _toDisplayString(item.unpacking_name) + " " + _toDisplayString(item.count > 1 ? ' x' + item.count : ''), 1)]);
  }), 128))])) : _createCommentVNode("", true), $data.showButtons ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", {
    class: "open_button cancel_button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleViewOrder && $options.handleViewOrder(...args))
  }, "查看订单"), _createElementVNode("div", {
    class: "open_button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.handleClose && $options.handleClose(...args))
  }, "好的")])) : _createCommentVNode("", true)]))], 2)], 64))]);
}